<!-- **
  *flv视频播放组件
* -->
<template>
    <div :class="classObject">
        <video :id="id" :autoplay="autoplay" :controls="controls"></video>
    </div>
</template>

<script>
const classNames = require('classnames')
import FlvExtend from '@/assets/js/flvExtend'
export default {
    name: "VideoPlayer",
    props: {
        id: {
            type: String,
            default: "video"
        },
        url: {
            type: String,
            default: ""
        },
        className: {
            type: String,
            default: ""
        },
        autoplay: {
            type: Boolean,
            default: false
        },
        isLive: {
            type: Boolean,
            default: false
        },
        controls: {
            type: Boolean,
            default: false
        },
    },
    components: {},
    data() {
        return {
            player: null,
        }
    },
    computed: {
        classObject: function () {
            return classNames({
                'VideoPlayer': true,
                [this.className]: !!this.className,
            })
        }
    },
    watch: {
        url(val) {
            if (!!val) {
                this.init()
            }
        },
    },
    methods: {
        //能耗指标
        async videoGetExeStatus() {
            this.init()
            // let res = await api.videoGetExeStatus();
            // console.log("videoGetExeStatus-----", res);
            // if (res && res.data) {
            //     this.init()
            // } else {
            //     console.log("未检测到转码服务，请运行相应的转码服务");
            // }
        },
        init() {
            this.destroy()
            try {
                console.log('----this.url,this.isLive----', this.url, this.isLive)
                const videoElement = document.getElementById(this.id)
                // 配置需要的功能
                const flv = new FlvExtend({
                    element: videoElement, // *必传
                    frameTracking: false, // 开启追帧设置
                    updateOnStart: this.isLive ? true : false, // 点击播放后更新视频
                    updateOnFocus: false, // 获得焦点后更新视频
                    reconnect: true, // 开启断流重连
                    reconnectInterval: 10 // 断流重连间隔
                })

                // 调用 init 方法初始化视频
                // init 方法的参数与 flvjs.createPlayer 相同，并返回 flvjs.player 实例
                this.player = flv.init(
                    {
                        type: 'flv',
                        url: this.url,
                        isLive: this.isLive
                    },
                    {
                        enableStashBuffer: false, // 如果您需要实时（最小延迟）来进行实时流播放，则设置为false
                        autoCleanupSourceBuffer: true, // 对SourceBuffer进行自动清理
                        stashInitialSize: 128 // 减少首帧显示等待时长
                    },
                    {
                        handlePlay: false,
                        callback: this.rebuildPlayer
                    },
                )
                this.player.onerror = (e) => {
                    console.log('this.player.onerror----', e)
                }
            } catch (error) {
                console.log(error, "---video--init---error---");
            }
        },
        destroy() {
            if (document.getElementById(this.id)) {
                document.getElementById(this.id).playbackRate = 1
            }
            if (this.player) {
                this.player.close();
            }
            this.player = null
        },
        rebuildPlayer(newPlayer) {
            console.log('---rebuildPlayer--newPlayer---', newPlayer)
            this.player = newPlayer
        }

    },
    created() {
    },
    mounted() {
        this.videoGetExeStatus()
        // this.init()
    },
    beforeDestroy() {
        this.destroy()
    },
}
</script> 

<style lang="scss" scoped>
.VideoPlayer {
    width: 100%;
    height: 100%;

    video {
        width: 100%;
        height: 100%;
    }
}
</style>